import { render, staticRenderFns } from "./FamilyRegister.vue?vue&type=template&id=6cd77567&scoped=true&"
import script from "./FamilyRegister.vue?vue&type=script&lang=js&"
export * from "./FamilyRegister.vue?vue&type=script&lang=js&"
import style0 from "./FamilyRegister.vue?vue&type=style&index=0&id=6cd77567&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cd77567",
  null
  
)

export default component.exports